import {ActionTree} from 'vuex';
import {AppState} from '@/store/app';
import {AttributesState} from '@/store/attributes/index';
import {
	CREATE_CONTACT_ATTRIBUTE,
	LOAD_CONTACT_ATTRIBUTES,
	UPDATE_CONTACT_ATTRIBUTE,
	ARCHIVE_CONTACT_ATTRIBUTE
} from '@/store/attributes/actionTypes';
import {messagingWorkspacesApi} from '@/messaging/messaging';
import {
	ADD_TO_CONTACT_ATTRIBUTE_CACHE,
	SET_CONTACT_ATTRIBUTES,
	UPDATE_CONTACT_ATTRIBUTE_IN_CACHE,
	ARCHIVE_CONTACT_ATTRIBUTE_IN_CACHE
} from '@/store/attributes/mutationTypes';
import {HANDLE_SERIOUS_ERROR} from '@/store/app/actionTypes';
import {CreateContactAttributeViewModel} from '@/messaging/models/createContactAttributeViewModel';

export const actions: ActionTree<AttributesState, AppState> = {
	async [LOAD_CONTACT_ATTRIBUTES]({commit, rootState, dispatch}) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		if (!currentWorkspace) {
			return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
		}

		const response = await messagingWorkspacesApi.getAttributesForWorkspace(currentWorkspace.id);
		commit(SET_CONTACT_ATTRIBUTES, response.attributes);
	},

	async [CREATE_CONTACT_ATTRIBUTE]({commit, rootState}, request: CreateContactAttributeViewModel) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		const createdAttribute = await messagingWorkspacesApi.createAttributeForWorkspace(currentWorkspace.id, request);
		commit(ADD_TO_CONTACT_ATTRIBUTE_CACHE, createdAttribute);
		return createdAttribute;
	},

	async [UPDATE_CONTACT_ATTRIBUTE]({commit, rootState}, { attributeId, request }) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		const updatedAttribute = await messagingWorkspacesApi.updateAttributeForWorkspace(currentWorkspace.id, attributeId, request);
		commit(UPDATE_CONTACT_ATTRIBUTE_IN_CACHE, updatedAttribute);
		return updatedAttribute;
	},

	async [ARCHIVE_CONTACT_ATTRIBUTE]({commit, rootState}, attributeId) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		await messagingWorkspacesApi.archiveAttributeForWorkspace(currentWorkspace.id, attributeId);
		commit(ARCHIVE_CONTACT_ATTRIBUTE_IN_CACHE, attributeId);
	},
};
